module.exports = __webpack_public_path__ + "calendar-full.6205658f742f6a73c91b86f07052371f.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/calendar-full.svg
// module id = 1656
// module chunks = 39